import { render, staticRenderFns } from "./CaptainsDeckHealth.vue?vue&type=template&id=6b49961c&scoped=true&"
import script from "./CaptainsDeckHealth.vue?vue&type=script&lang=js&"
export * from "./CaptainsDeckHealth.vue?vue&type=script&lang=js&"
import style0 from "./CaptainsDeckHealth.vue?vue&type=style&index=0&id=6b49961c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b49961c",
  null
  
)

export default component.exports